import React from 'react';
import { UserIcon } from '@heroicons/react/24/solid';
import { messages } from '../constants/messages';
import { useContent } from '../ContentContext';

const ChairmanMessage = () => {
  const { content } = useContent();
  const ch = (content as any).chairman || {};

  const name        = ch.name        || messages.chairman.name;
  const designation = ch.designation || messages.chairman.designation;
  const quote       = ch.quote       || messages.chairman.quote;

  return (
    <section className="py-24 px-4 sm:px-10 bg-gray-50">
      <div className="container mx-auto grid md:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="rounded-[2.5rem] overflow-hidden shadow-2xl relative z-10 border-[12px] border-white">
            <img
              src="/images/chairman.jpeg"
              alt={name}
              className="w-full object-cover aspect-[4/5]"
            />
          </div>
          <div className="absolute -bottom-8 right-8 bg-white p-8 rounded-3xl shadow-xl z-20 border border-gray-100 max-w-[280px]">
            <h4 className="font-extrabold text-2xl text-gray-900 leading-tight">{name}</h4>
            <p className="text-[#EF5D22] font-bold uppercase tracking-widest text-xs mt-1">{designation}</p>
            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center space-x-2 text-gray-500 italic text-sm">
              <UserIcon className="w-5 h-5 text-[#EF5D22]" />
              <span>{messages.chairman.legacy}</span>
            </div>
          </div>
          <div className="absolute -top-10 -left-10 w-40 h-40 bg-[#0066CC]/10 rounded-full blur-2xl"></div>
        </div>
        <div className="md:pl-10">
          <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-sm mb-4 block">{messages.chairman.badge}</span>
          <h2 className="text-4xl sm:text-5xl font-extrabold mb-8 text-gray-900 leading-tight">
            {messages.chairman.titlePart1} <br /><span className="text-[#EF5D22]">{messages.chairman.titlePart2}</span>
          </h2>
          <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
            <div
              className="font-medium text-gray-800 italic prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{ __html: quote }}
            />
            <p>{messages.chairman.p1}</p>
            <p>{messages.chairman.p2}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmanMessage;
